import React, { useEffect, useState } from "react";
import { EditBlockOption } from "../EditBlock";
import { OptionIsRight, TopicType } from "../../../../../service/homework";
import { EditTianKongPure } from "../../../../exam/addExam/components/EditTiankong";
import { EditBlock } from "../EditBlock";
import { QuestionType } from "../../../../../service/service";

interface EditTianKongProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditTianKong({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditTianKongProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const handleOnChange = (value: string, index: number) => {
        const newTopic = { ...topic };
        newTopic.answers[index].content = value;
        newTopic.answers[index].isRight = OptionIsRight.Right;
        setInnerTopic(newTopic);
    };

    const handleDelete = (index: number) => {
        const newTopic = { ...topic };
        newTopic.answers.splice(index, 1);
        setInnerTopic(newTopic);
    };

    const handleAdd = () => {
        const newTopic = { ...topic };
        newTopic.answers.push({ content: "", isRight: OptionIsRight.Right });
        setInnerTopic(newTopic);
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.TianKong}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditTianKongPure
                innerTopic={innerTopic}
                topic={topic}
                handleOnChange={handleOnChange}
                handleDelete={handleDelete}
                handleAdd={handleAdd}
            />
        </EditBlock>
    );
}
